<div class="button_quanity">
  <div class="editor-header" *ngIf="isViewAll" style="cursor: pointer">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }} <span
        style="text-transform: lowercase;">{{fields_style_basic}}</span></span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['btn-quantity-cart']['width']"
      [height]="class['btn-quantity-cart']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline">
      <!-- CẤU HÌNH THÔNG SỐ CƠ BẢN -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="items">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
          <div class="display-device">
            <div class="title">
              {{'an_nut_tang_giam_so_luong' | translate}}
            </div>
            <nz-switch [(ngModel)]="config.hidden.hidden_amount" (ngModelChange)="updateConfig()"></nz-switch>
          </div>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế--> 
      
      <li nz-submenu [nzTitle]="'kich_thuoc' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')"
        *ngIf="!config.hidden.hidden_amount">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <div class="items">
          <div class="font-size-icon">
            <div class="mt-2 slide-bar">
              <p class="m-0 title">{{'khoang_cach' | translate}} </p>
              <input matInput type="number" class="input-number"
                [ngModel]="class['btn-quantity-cart__input']['gap'] | vhnumber"
                (ngModelChange)="class['btn-quantity-cart__input']['gap'] = $event +'px';">
            </div>
            <div class="font-size">
              <nz-slider [nzMin]="0" [nzMax]="20" [ngModel]="class['btn-quantity-cart__input']['gap'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="class['btn-quantity-cart__input']['gap'] = $event +'px'"></nz-slider>
            </div>
          </div>
          <div class="contains-style">
            <button class="style-item" *ngFor="let basic of configStyleBasic" (click)=" chooseBasic(basic)">
              <span style="font-size: 13px; white-space: nowrap">{{basic.title}}</span>
            </button>
          </div>

        </div>
      </li>
      <!-- CẤU HÌNH VIỀN -->
      <li nz-submenu [nzTitle]="'duong_vien' | translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="contains-style">
          <button class="style-item" *ngFor="let style of configStyleBasic" (click)="chooseBorder(style)"
            [disabled]="style.title === 'Nút tăng giảm' && config.hidden.hidden_amount"
            [ngClass]="{'disable': style.title === 'Nút tăng giảm' && config.hidden.hidden_amount}">
            <span style="font-size:13px;white-space: nowrap">{{style.title}}</span>
          </button>
        </div>
      </li>
      <!-- Đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['btn-quantity-cart']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(fieldsConfig[5])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- CẤU HÌNH BO TRÒN -->
      <li nz-submenu [nzTitle]="'bo_tron' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="contains-style">
          <button class="style-item" *ngFor="let style of configStyleBasic" (click)="chooseBorderRadius(style)"
            [disabled]="style.title === 'Nút tăng giảm' && config.hidden.hidden_amount"
            [ngClass]="{'disable': style.title === 'Nút tăng giảm' && config.hidden.hidden_amount}">
            <span style="font-size:13px;white-space: nowrap">{{style.title}}</span>
          </button>
        </div>
      </li>
      <!-- CẤU HÌNH MÀU SẮC -->
      <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="contains-color">
          <button class="color-quantity" *ngFor="let style of configStyleBasic" (click)="chooseColor(style)"
            [disabled]="style.title === 'Nút tăng giảm' && config.hidden.hidden_amount"
            [ngClass]="{'disable': style.title === 'Nút tăng giảm' && config.hidden.hidden_amount}">
            <span style="font-size:13px;white-space: nowrap">{{style.title}}</span>
          </button>
        </div>
      </li>
      <!-- CẤU HÌNH BIỂU TƯỢNG -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="contains-icon">
          <button class="icon-quantity" *ngFor="let icon of configStyleIcon" (click)="chooseIcon(icon)"
            [ngClass]="{'disable': config.hidden.hidden_amount}" [disabled]="config.hidden.hidden_amount">
            <span style="font-size:13px;white-space: nowrap">{{icon.title}}</span>
          </button>
        </div>
      </li>
      <!-- CẤU HÌNH NHÃN -->
      <li nz-submenu nzTitle="{{'nhan' | translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
        <div [matTooltip]="'*_giai_thich_aria_label' | translate">
          <!-- Nếu nội dung không có thì phải có nhãn -->
          <mat-form-field style="width: 100%" class="aria-label-input">
            <mat-label>{{'nhan_cua_o_nhap' | translate}}<span style="color: red">*</span></mat-label>
            <textarea matInput
              [ngModel]="staticdata?.accessibility?.['aria_label_input_' + functionService.selectedLanguageCode]"
              (ngModelChange)="staticdata.accessibility['aria_label_input_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateContent('aria_label_input');"></textarea>
          </mat-form-field>
          <ng-container>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%; margin-top: 10px" class="aria-label-input">
              <mat-label>{{'nhan_cua_nut_giam' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata?.accessibility?.['aria_label_dec_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_dec_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('aria_label_dec');"></textarea>
            </mat-form-field>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%; margin-top: 10px" class="aria-label-input">
              <mat-label>{{'nhan_cua_nut_tang' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata?.accessibility?.['aria_label_inc_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_inc_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('aria_label_inc');"></textarea>
            </mat-form-field>
          </ng-container>
        </div>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['btn-quantity-cart']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
    </ul>
  </ng-container>
  <div class="view-more" *ngIf="isViewAll">
    <!-- CẤU HÌNH CHI TIẾT THÔNG SỐ CƠ BẢN -->
    <div class="style-basic" *ngIf="currentViewAll.index == 1">
      <div class="field-basic" *ngIf="fields_style_basic == 'Nút tăng giảm'">
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_rong' | translate}}</p>
            <input class="input-number" type="text" [ngModel]="class['btn-quantity-cart__amount'].width | vhpercent"
              #widthvalue (ngModelChange)="class['btn-quantity-cart__amount'].width = $event;"
              (blur)="class['btn-quantity-cart__amount'].width = widthvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity-cart__amount'].width | vhnumber" [nzMin]="1" [nzMax]="100"
            [nzStep]="1" (ngModelChange)="class['btn-quantity-cart__amount'].width = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_cao' | translate}}</p>
            <input class="input-number" type="text" [ngModel]="class['btn-quantity-cart__amount'].height | vhpercent"
              #heightvalue (ngModelChange)="class['btn-quantity-cart__amount'].height = $event;"
              (blur)="class['btn-quantity-cart__amount'].height = heightvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity-cart__amount'].height | vhnumber" [nzMin]="1" [nzMax]="100"
            [nzStep]="1" (ngModelChange)="class['btn-quantity-cart__amount'].height = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
      </div>
      <div class="field-basic" *ngIf="fields_style_basic == 'Ô số lượng'">
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_rong' | translate}}</p>
            <input class="input-number" type="text" [ngModel]="class['btn-quantity-cart__input'].width | vhpercent"
              #widthvalue (ngModelChange)="class['btn-quantity-cart__input'].width = $event;"
              (blur)="class['btn-quantity-cart__input'].width = widthvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity-cart__input'].width | vhnumber" [nzMin]="1" [nzMax]="100"
            [nzStep]="1" (ngModelChange)="class['btn-quantity-cart__input'].width = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_cao' | translate}}</p>
            <input class="input-number" type="text" [ngModel]="class['btn-quantity-cart__input'].height | vhpercent"
              #heightvalue (ngModelChange)="class['btn-quantity-cart__input'].height = $event;"
              (blur)="class['btn-quantity-cart__input'].height = heightvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity-cart__input'].height | vhnumber" [nzMin]="1" [nzMax]="100"
            [nzStep]="1" (ngModelChange)="class['btn-quantity-cart__input'].height = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
      </div>
      <div class="field-basic" *ngIf="fields_style_basic == 'Nút tăng'">
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_rong' | translate}}</p>
            <input class="input-number" type="text"
              [ngModel]="class['btn-quantity-cart__increase-amount'].width | vhpercent" #widthvalue
              (ngModelChange)="class['btn-quantity-cart__increase-amount'].width = $event;"
              (blur)="class['btn-quantity-cart__increase-amount'].width = widthvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity-cart__increase-amount'].width | vhnumber" [nzMin]="1" [nzMax]="100"
            [nzStep]="1" (ngModelChange)="class['btn-quantity-cart__increase-amount'].width = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_cao' | translate}}</p>
            <input class="input-number" type="text"
              [ngModel]="class['btn-quantity-cart__increase-amount'].height | vhpercent" #heightvalue
              (ngModelChange)="class['btn-quantity-cart__increase-amount'].height = $event;"
              (blur)="class['btn-quantity-cart__increase-amount'].height = heightvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity-cart__increase-amount'].height | vhnumber" [nzMin]="1" [nzMax]="100"
            [nzStep]="1" (ngModelChange)="class['btn-quantity-cart__increase-amount'].height = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
      </div>
    </div>
    <!-- CẤU HÌNH CHI TIẾT HÌNH DẠNG VIỀN -->
    <div class="style-border" *ngIf="currentViewAll.index == 2">
      <div class="field-border" *ngIf="fields_style_border == 'Nút tăng giảm'">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['btn-quantity-cart__amount']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
      </div>
      <div class="field-border" *ngIf="fields_style_border == 'Ô số lượng'">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['btn-quantity-cart__input']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
      </div>
    </div>
    <!-- CẤU HÌNH CHI TIẾT BO TRÒN -->
    <div class="style-border" *ngIf="currentViewAll.index == 5">
      <div class="field-border mt-1" *ngIf="fields_style_border == 'Nút tăng giảm'">
        <!-- BO TRÒN VIỀN -->
        <app-borders-radius-config [device]="device" [class]="class"
          [borderRadiusClass]="class['btn-quantity-cart__amount']" [id_object]="objectChoosing._id">
        </app-borders-radius-config>
      </div>
      <div class="field-border mt-1" *ngIf="fields_style_border == 'Ô số lượng'">
        <!-- BO TRÒN VIỀN -->
        <app-borders-radius-config [device]="device" [class]="class"
          [borderRadiusClass]="class['btn-quantity-cart__input']" [id_object]="objectChoosing._id">
        </app-borders-radius-config>
      </div>
    </div>
    <!-- CẤU HÌNH CHI TIẾT MÀU SẮC -->
    <div class="style-color" *ngIf="currentViewAll.index == 3">
      <div class="field-color" *ngIf="fields_style_color == 'Nút tăng giảm'">
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{'background-color':background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip>
          </button>
        </div>
        <div class="d-flex align-items-center mt-2">
          <span class="hidden-text mr-2 w-50">{{'chon_mau' | translate}}</span>
          <input class="input-color w-50" type="button"
            [cpOKButton]="true" [(colorPicker)]="class['btn-quantity-cart__amount']['background-color']"
            [style.background]="class['btn-quantity-cart__amount']['background-color'] "
            (colorPickerClose)="updateObject()" />
        </div>
      </div>
      <!-- Ô số lượng -->
      <div class="field-color" *ngIf="fields_style_color == 'Ô số lượng'">
        <div class="container-font">
          <div class="config-font-size">
            <div class="field-row-font" style="width: 65%">
              <mat-form-field style="width: 100%">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="
                              class['btn-quantity-cart__input']['font-family']
                            " (ngModelChange)="updateClass()"
                  [(value)]="class['btn-quantity-cart__input']['font-family']">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                    font.name
                    }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="field-row-size" style="width: 35%">
              <mat-form-field style="width: 100%">
                <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                <input matInput type="number" (blur)="updateClass()" (keyup.enter)="updateClass()" [ngModel]="
                              class['btn-quantity-cart__input']['font-size'] | vhnumber
                            " (ngModelChange)="
                              class['btn-quantity-cart__input']['font-size'] =
                                $event + 'px'
                            " />
              </mat-form-field>
            </div>
          </div>
          <div class="config-font">
            <p class="title-font">{{'kieu_chu' | translate}}</p>
            <div class="field-row">
              <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                            class['btn-quantity-cart__input']['font-weight'] == 'bold'
                              ? 'primary'
                              : 'default'
                          " (click)="
                            class['btn-quantity-cart__input']['font-weight'] =
                              class['btn-quantity-cart__input']['font-weight'] == 'bold'
                                ? '500'
                                : 'bold';
                            updateClass()
                          ">
                <span style="font-weight: 600">B</span>
              </button>
              <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                            class['btn-quantity-cart__input']['font-style'] == 'italic'
                              ? 'primary'
                              : 'default'
                          " (click)="
                            class['btn-quantity-cart__input']['font-style'] =
                              class['btn-quantity-cart__input']['font-style'] == 'normal'
                                ? 'italic'
                                : 'normal';
                            updateClass()
                          ">
                <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                            class['btn-quantity-cart__input']['text-decoration'] ==
                            'underline'
                              ? 'primary'
                              : 'default'
                          " (click)="
                            class['btn-quantity-cart__input']['text-decoration'] =
                              class['btn-quantity-cart__input']['text-decoration'] ==
                              'none'
                                ? 'underline'
                                : 'none';
                            updateClass()
                          ">
                <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                            class['btn-quantity-cart__input']['text-transform'] ==
                            'uppercase'
                              ? 'primary'
                              : 'default'
                          " (click)="
                            class['btn-quantity-cart__input']['text-transform'] =
                              class['btn-quantity-cart__input']['text-transform'] ==
                              'none'
                                ? 'uppercase'
                                : 'none';
                            updateClass()
                          ">
                <span>AB</span>
              </button>
              <div>
                <input id="color" [cpOKButton]="true" [(colorPicker)]="class['btn-quantity-cart__input'].color" type="button"
                  [style.background]="class['btn-quantity-cart__input'].color" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
              </div>
            </div>
          </div>
        </div>
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{'background-color':background.bgColor }" (click)="chooseBgInput(background, $event)" nz-tooltip>
          </button>
        </div>
        <div class="color-pick d-flex justify-content-between mt-2">
          <span class="hidden-text w-50">{{'chon_mau' | translate}}</span>
          <input class="input-color w-50" type="button"
            [cpOKButton]="true" [(colorPicker)]="class['btn-quantity-cart__input']['background-color']"
            [style.background]="class['btn-quantity-cart__input']['background-color']"
            (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
        </div>
      </div>
    </div>
    <!-- CẤU HÌNH CHI TIẾT ICON -->
    <div class="style-icon" *ngIf="currentViewAll.index == 4">
      <div class="field-icon" *ngIf="fields_style_icon == 'Nút giảm'">
        <div class="selectedIcon">
          <div class="ml-3">
            <mat-icon>{{config.icon.icon_minus}}</mat-icon>
          </div>
          <button nz-button nzType="default" (click)="openDialogChooseIcon()">{{'thay_doi' | translate}}</button>
        </div>
        <div class="font-size-icon">
          <div class="mt-2 slide-bar">
            <p class="m-0 title" style="line-height:1.5">{{'kich_thuoc' | translate}}</p>
            <input matInput type="number" class="input-number" (blur)="updateClass()" (keyup.enter)="updateClass()"
              [ngModel]="class['btn-quantity-cart__amount--increase-icon']['font-size'] | vhnumber"
              (ngModelChange)="class['btn-quantity-cart__amount--increase-icon']['font-size'] = $event +'px';">
          </div>
          <div class="font-size">
            <nz-slider [nzMin]="0" [nzMax]="50"
              [ngModel]="class['btn-quantity-cart__amount--increase-icon']['font-size'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['btn-quantity-cart__amount--increase-icon']['font-size'] = $event +'px' "></nz-slider>
          </div>
        </div>
        <div class="item-border">
          <p class="m-0 title w-50" style="line-height:1.5">{{ 'mau_sac' | translate }}</p>
          <input class="input-color w-50" type="button"
            [cpOKButton]="true" [(colorPicker)]="class['btn-quantity-cart__amount--increase-icon'].color"
            [style.background]="class['btn-quantity-cart__amount--increase-icon'].color"
            (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
        </div>
      </div>
      <div class="field-icon" *ngIf="fields_style_icon == 'Nút tăng'">
        <div class="selectedIcon">
          <div class="ml-3">
            <mat-icon>{{config.icon.icon_plus}}</mat-icon>
          </div>
          <button nz-button nzType="default" (click)="openDialogChooseIcon()">{{'thay_doi' | translate}}</button>
        </div>
        <div class="font-size-icon">
          <div class="mt-2 slide-bar">
            <p class="m-0 title" style="line-height:1.5">{{'kich_thuoc' | translate}}</p>
            <input matInput type="number" class="input-number" (blur)="updateClass()" (keyup.enter)="updateClass()"
              [ngModel]="class['btn-quantity-cart__amount--decrease-icon']['font-size'] | vhnumber"
              (ngModelChange)="class['btn-quantity-cart__amount--decrease-icon']['font-size'] = $event +'px';">
          </div>
          <div class="font-size">
            <nz-slider [nzMin]="0" [nzMax]="50"
              [ngModel]="class['btn-quantity-cart__amount--decrease-icon']['font-size'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['btn-quantity-cart__amount--decrease-icon']['font-size'] = $event +'px'"></nz-slider>
          </div>
        </div>
        <div class="item-border">
          <p class="m-0 title w-50" style="line-height:1.5">{{ 'mau_sac' | translate }}</p>
          <input class="input-color w-50" type="button"
            [cpOKButton]="true" [(colorPicker)]="class['btn-quantity-cart__amount--decrease-icon'].color"
            [style.background]="class['btn-quantity-cart__amount--decrease-icon'].color"
            (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
        </div>
      </div>
    </div>

    <div class="style-icon" *ngIf="currentViewAll.index == 6">
      <app-borders-radius-config 
        [device]="device" 
        [class]="class" 
        [borderRadiusClass]="class['btn-quantity-cart']"
        [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>
  </div>
</div>